import { Box } from '@mui/material'
import useSubdomain from 'hooks/useSubdomain/useSubdomain'
import { SnackbarProvider } from 'notistack'
import { Redirect } from 'react-router-dom'
import CreateCompany from 'views/CreateCompany/CreateCompany'

function RegisterPageMain() {
    return (
        <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            autoHideDuration={3000}
            preventDuplicate
        >
            <Box
                sx={{
                    backgroundImage:
                        'radial-gradient(circle, rgba(90, 223, 180, 1) 0%, rgba(18, 174, 133, 1) 50%, rgba(16, 172, 132, 1) 100%)',
                    overscrollBehavior: 'contain',
                    position: {
                        sm: 'relative',
                        xs: 'relative',
                        md: 'fixed',
                    },
                    height: {
                        sm: '101vh',
                        xs: '101vh',
                        md: '100vh',
                    },
                    width: '100%',
                }}
            >
                <CreateCompany />
            </Box>
        </SnackbarProvider>
    )
}

function RegisterPage() {
    const { hasSubDomain } = useSubdomain()

    if (hasSubDomain) {
        return <Redirect to="/" />
    }
    return <RegisterPageMain />
}

export default RegisterPage
